import { render, staticRenderFns } from "./WordCloudContent.vue?vue&type=template&id=277b30f3&scoped=true&"
import script from "./WordCloudContent.vue?vue&type=script&lang=js&"
export * from "./WordCloudContent.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudContent.vue?vue&type=style&index=0&id=277b30f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b30f3",
  null
  
)

export default component.exports